import axiosInstance from 'core/network/axiosInstance'

export interface OrderAddressApi {
  street: string
  city: string
  state: string
  zip: string
}

export interface OrderBuyerApi {
  id: string
  name: string
  business_name?: string
  phone: string
  email: string
  role: string
}

export interface OrderPaymentApi {
  id: string
  amount: number
  payment_date?: string
  payment_mode: string
  status: string
  screenshot_url?: string
  verified_at?: string
  rejection_reason?: string
}

export interface OrderItemApi {
  id: string
  catalog_item_id: string
  product_name: string
  variant: string
  unit?: string
  units: number
  qty: number
  unit_price?: number
  subtotal?: number
}

export interface OrderListItemApi {
  id: string
  status: string
  version: number
  payment_mode: string
  order_placed_date: string
  requested_delivery_date?: string
  total_amount?: number
  bill_to_address: OrderAddressApi
  ship_to_address: OrderAddressApi
  buyer?: OrderBuyerApi
  payment_status: string
  moq_check: boolean
  is_repeat: boolean
  has_grievance: boolean
  items?: OrderItemApi[]
  created_at: string
  updated_at: string
}

export interface StatusHistoryEntryApi {
  status: string
  changed_at: string
}

export interface OrderDetailApi {
  id: string
  status: string
  version: number
  moq_check: boolean
  moq_warning?: boolean
  is_repeat: boolean
  has_grievance: boolean
  payment_mode: string
  order_placed_date: string
  requested_delivery_date?: string
  total_amount?: number
  remarks?: string
  bill_to_address: OrderAddressApi
  ship_to_address: OrderAddressApi
  buyer?: OrderBuyerApi
  payments: OrderPaymentApi[]
  items: OrderItemApi[]
  status_history?: StatusHistoryEntryApi[]
  created_at: string
  updated_at: string
}

export interface OrderListApiResponse {
  skip: number
  limit: number
  total: number
  data: OrderListItemApi[]
}

export interface GetOrdersApiParams {
  skip: number
  limit: number
  status?: string
  search?: string
  moq_check?: boolean
  catalog_item_id?: string
}

export interface UpdateOrderStatusApiRequest {
  status: string
  version: number
}

export interface UpdateOrderStatusApiResponse {
  status: string
  version: number
}

class OrderApiDatasource {
  async getOrders(params: GetOrdersApiParams): Promise<OrderListApiResponse> {
    const { data } = await axiosInstance.get<OrderListApiResponse>('/api/v1/indents/enriched', { params })
    return data
  }

  async getOrderDetail(id: string): Promise<OrderDetailApi> {
    const { data } = await axiosInstance.get<OrderDetailApi>(`/api/v1/indents/${id}/detail`)
    return data
  }

  async updateOrderStatus(id: string, payload: UpdateOrderStatusApiRequest): Promise<UpdateOrderStatusApiResponse> {
    const { data } = await axiosInstance.put<UpdateOrderStatusApiResponse>(`/api/v1/indents/${id}/status`, payload)
    return data
  }
}

export const orderApiDatasource = new OrderApiDatasource()
